<template>
  <Modal
    content-class="tw:flex-1"
    :modal-style="modalStyle"
    offset-menu
    :title="$t('expandable_filters.title')"
    @close="emit('close')"
  >
    <ExpandableFilters
      class="tw:mb-0 tw:h-full tw:px-0"
      data-testid="expandable-filters"
      :date-range="dateRange"
      :filters="filters"
      :hide-date-range="hideDateRange"
      show-apply
      :show-categories="showCategories"
      :show-included-mentions="showIncludedMentions"
      :show-last-saved-toggle="showLastSavedToggle"
      :show-tiers="showTiers"
      :sorting-options="sortingOptions"
      :stream="stream"
      @apply="handleApply"
      @reset="handleReset"
      @update:filters="emit('update:filters', $event)"
      @update:sorting-options="emit('update:sortingOptions', $event)"
    />
  </Modal>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Modal from "shared/components/core/modals/Modal.vue";
import ExpandableFilters from "shared/components/selectors/ExpandableFilters.vue";
import DateRange from "shared/helpers/DateRange";
import type { StreamFiltersSortOption } from "shared/helpers/StreamFilters";
import type StreamFilters from "shared/helpers/StreamFilters";
import type { Nullable, Stream } from "shared/types";

export interface Props {
  stream: Stream;
  filters?: StreamFilters;
  dateRange?: DateRange;
  sortingOptions?: Nullable<StreamFiltersSortOption[]>;
  showCategories?: boolean;
  showIncludedMentions?: boolean;
  showLastSavedToggle?: boolean;
  showTiers?: boolean;
  hideDateRange?: boolean;
}

withDefaults(defineProps<Props>(), {
  filters: undefined,
  dateRange: () => DateRange.today(),
  sortingOptions: null,
});

const emit = defineEmits<{
  close: [];
  "update:filters": [StreamFilters];
  "update:sortingOptions": [Array<unknown>];
  reset: [StreamFilters];
  apply: [StreamFilters];
}>();

const modalStyle = computed<{
  maxWidth: string;
  height: string;
}>(() => ({
  maxWidth: "800px",
  height: "80vh",
}));

function handleReset(filters: StreamFilters): void {
  emit("reset", filters);
}

function handleApply(filters: StreamFilters): void {
  emit("apply", filters);
  emit("close");
}
</script>
